import eventEmitter from "../state/EventEmitter";
import EmittedEvent from "../types/EmittedEvent";
import API from "./API";

class ModelImages {
  images: ModelImage[] = [];

  constructor(
    pages: number,
    data: { modelName: string; batchClassIdentifier: string; uuid: string },
  ) {
    this.images = Array.from(Array(pages).keys()).map(
      (x) => new ModelImage(x, data),
    );
  }

  addImages(images: ModelImage[]) {
    this.images = images;
  }
}

class ModelImage {
  private index: number = 0;
  private blobString?: string;
  private base64String?: string;
  private imageObject?: HTMLImageElement;

  width: number = 0;
  height: number = 0;

  uuid: string;
  modelName: string;
  batchClassId: string;

  status: "loading" | "loaded" | "notCalled" = "notCalled";

  constructor(
    index: number,
    data: { modelName: string; batchClassIdentifier: string; uuid: string },
  ) {
    this.index = index;
    this.uuid = data.uuid;
    this.batchClassId = data.batchClassIdentifier;
    this.modelName = data.modelName;
  }

  data(): string {
    if (this.base64String != null) return this.base64String;
    this.loadData();
    return "";
  }

  imageNode(): HTMLImageElement | null {
    if (this.imageObject == null) return null;
    return this.imageObject;
  }

  async loadData(): Promise<string> {
    if (this.blobString != null) return this.blobString;
    this.status = "loading";

    const response: Blob | null = await API.get(
      `/v0/modelimage/${this.batchClassId}/${this.uuid}/${this.index}`,
    )
      .then((value: Response) => value.blob())
      .catch(() => {
        return null;
      });

    if (response == null) this.blobString = "";
    else {
      this.blobString = URL.createObjectURL(response);

      const reader = new FileReader();
      reader.readAsDataURL(response);
      reader.onload = () => {
        this.status = "loaded";
        this.base64String = reader.result?.toString() ?? "";
        if (this.base64String === "")
          return eventEmitter.publish(
            new EmittedEvent("loadedModelImage", {
              modelName: this.modelName,
              batchClassId: this.batchClassId,
            }),
          );

        // create Image object to get width/height
        this.imageObject = new Image();
        this.imageObject.onload = () => {
          this.width = this.imageObject!.width;
          this.height = this.imageObject!.height;
          eventEmitter.publish(
            new EmittedEvent("loadedModelImage", {
              modelName: this.modelName,
              batchClassId: this.batchClassId,
            }),
          );
        };
        this.imageObject.src = this.base64String!;
      };
    }
    return this.blobString;
  }
}

export { ModelImage };
export default ModelImages;
